/* FRESIA · interacciones de las secciones fr-*
   Sin dependencias. Se inicializa por sección (también al añadirla
   desde el editor de temas). */
(function () {
  'use strict';

  var DESKTOP = 760;

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function fmt(cents, moneyFormat) {
    var f = moneyFormat || (window.Theme && window.Theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100);
    var withComma = v.toFixed(2).replace('.', ',');
    var noDec = withComma.replace(/,00$/, '');
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, v.toFixed(2));
  }

  /* ---------------- carruseles ---------------- */
  function initScroller(root) {
    qsa(root, '[data-fr-scroller]').forEach(function (sc) {
      if (sc.__fr) return; sc.__fr = true;
      var group = sc.closest('[data-fr-carousel]') || root;
      var prev = qs(group, '[data-fr-prev]');
      var next = qs(group, '[data-fr-next]');
      var dots = qs(group, '[data-fr-dots]');
      var items = function () { return qsa(sc, ':scope > *'); };

      function pageWidth() { return sc.clientWidth; }
      function perPage() {
        var it = items(); if (!it.length) return 1;
        var w = it[0].getBoundingClientRect().width || 1;
        var gap = parseFloat(getComputedStyle(sc).columnGap || getComputedStyle(sc).gap) || 0;
        return Math.max(1, Math.round((pageWidth() + gap) / (w + gap)));
      }
      function pages() { return Math.max(1, Math.ceil(items().length / perPage())); }
      function current() {
        var it = items(); if (!it.length) return 0;
        var w = it[0].getBoundingClientRect().width || 1;
        var gap = parseFloat(getComputedStyle(sc).columnGap || getComputedStyle(sc).gap) || 0;
        var idx = Math.round(sc.scrollLeft / (w + gap));
        return Math.min(pages() - 1, Math.floor(idx / perPage()));
      }
      function goTo(p) {
        var it = items(); if (!it.length) return;
        var i = Math.min(it.length - 1, p * perPage());
        sc.scrollTo({ left: it[i].offsetLeft - sc.offsetLeft - parseFloat(getComputedStyle(sc).paddingLeft || 0), behavior: 'smooth' });
      }
      function renderDots() {
        if (!dots) return;
        var n = pages(), c = current();
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button'; b.setAttribute('aria-label', 'Ir a la página ' + (i + 1));
            b.addEventListener('click', (function (k) { return function () { goTo(k); }; })(i));
            dots.appendChild(b);
          }
        }
        qsa(dots, 'button').forEach(function (b, i) { b.classList.toggle('on', i === c); });
        dots.hidden = n <= 1;
        if (prev) prev.disabled = c === 0;
        if (next) next.disabled = c >= n - 1;
      }
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(pages() - 1, current() + 1)); });
      var t; sc.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(renderDots, 60); }, { passive: true });
      window.addEventListener('resize', renderDots);
      renderDots();
    });
  }

  /* ---------------- pestañas de productos ---------------- */
  function initTabs(root) {
    qsa(root, '[data-fr-tabs]').forEach(function (tabs) {
      if (tabs.__fr) return; tabs.__fr = true;
      var grid = qs(root, '[data-fr-tab-grid]');
      var btns = qsa(tabs, '[data-fr-tab]');
      function show(key) {
        btns.forEach(function (b) {
          var on = b.getAttribute('data-fr-tab') === key;
          b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (!grid) return;
        qsa(grid, '[data-fr-tab-item]').forEach(function (it) {
          var k = it.getAttribute('data-fr-tab-item');
          it.hidden = !(key === '*' || !k || k === key);
        });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-fr-tab')); }); });
      var first = qs(tabs, '.on') || btns[0];
      if (first) show(first.getAttribute('data-fr-tab'));
    });
  }

  /* ---------------- marquesina ---------------- */
  function initMarquee(root) {
    qsa(root, '.fr-band--anim .fr-band__track').forEach(function (tr) {
      if (tr.__fr) return; tr.__fr = true;
      var html = tr.innerHTML;
      // Se duplica hasta cubrir el doble del ancho visible para que el bucle sea continuo
      var guard = 0;
      while (tr.scrollWidth < (tr.parentElement.clientWidth * 2) && guard < 8) { tr.innerHTML += html; guard++; }
      tr.innerHTML += tr.innerHTML; // par exacto para el translateX(-50%)
    });
  }

  /* ---------------- vídeos UGC ---------------- */
  function initVideos(root) {
    qsa(root, '.fr-vid').forEach(function (v) {
      if (v.__fr) return; v.__fr = true;
      var video = qs(v, 'video'); var play = qs(v, '.fr-play');
      if (!video) return;
      function toggle() {
        if (video.paused) { video.muted = false; video.play(); v.classList.add('is-playing'); }
        else { video.pause(); v.classList.remove('is-playing'); }
      }
      if (play) play.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
      video.addEventListener('ended', function () { v.classList.remove('is-playing'); });
    });
  }

  /* ---------------- acordeón (cerrar los demás) ---------------- */
  function initFaq(root) {
    qsa(root, '.fr-faq[data-fr-single]').forEach(function (faq) {
      if (faq.__fr) return; faq.__fr = true;
      faq.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        qsa(faq, 'details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  /* ---------------- ficha de producto ---------------- */
  function initProduct(root) {
    var pdp = (root.nodeType === 1 && root.matches('[data-fr-pdp]')) ? root : qs(root, '[data-fr-pdp]');
    if (!pdp || pdp.__fr) return; pdp.__fr = true;

    var form = qs(pdp, 'form[data-type="add-to-cart-form"]');
    var idInput = form && qs(form, 'input[name="id"]');
    var planInput = form && qs(form, 'input[name="selling_plan"]');
    var qtyInput = form && qs(form, 'input[name="quantity"]');
    var qtyLabel = qs(pdp, '[data-fr-qty-label]');
    var packs = qsa(pdp, 'input[name="fr-pack"]');
    var ctaPrice = qs(pdp, '[data-fr-cta-price]');
    var subCheck = qs(pdp, '[data-fr-sub]');
    var subPct = parseFloat(pdp.getAttribute('data-sub-discount') || '0');
    var money = pdp.getAttribute('data-money-format') || '';

    function selected() {
      var on = packs.filter(function (p) { return p.checked; })[0] || packs[0];
      return on ? on.closest('.fr-pack') : null;
    }
    function state() {
      var p = selected();
      if (!p) return null;
      var price = parseInt(p.getAttribute('data-price') || '0', 10);
      var sub = !!(subCheck && subCheck.checked);
      var plan = p.getAttribute('data-plan') || '';
      if (sub && p.getAttribute('data-plan-price')) price = parseInt(p.getAttribute('data-plan-price'), 10);
      return {
        variant: p.getAttribute('data-variant'),
        name: p.getAttribute('data-name') || '',
        price: price,
        priceText: fmt(price, money),
        plan: sub ? plan : '',
        qty: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      };
    }
    function sync() {
      var s = state(); if (!s) return;
      if (idInput && s.variant) idInput.value = s.variant;
      if (planInput) planInput.value = s.plan;
      if (ctaPrice) ctaPrice.textContent = s.priceText;
      document.dispatchEvent(new CustomEvent('fr:pack', { detail: s }));
    }
    packs.forEach(function (p) { p.addEventListener('change', sync); });
    if (subCheck) subCheck.addEventListener('change', sync);
    qsa(pdp, '[data-fr-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-fr-qty'), 10);
        qtyInput.value = Math.max(1, v);
        if (qtyLabel) qtyLabel.textContent = qtyInput.value;
        sync();
      });
    });

    // galería: miniaturas y puntos
    var main = qs(pdp, '[data-fr-gal-main] img');
    var thumbs = qsa(pdp, '[data-fr-thumb]');
    var gdots = qsa(pdp, '[data-fr-gal-dots] span');
    function showMedia(i) {
      var t = thumbs[i]; if (!t || !main) return;
      var src = t.getAttribute('data-src'); var srcset = t.getAttribute('data-srcset');
      if (src) { main.style.opacity = '0'; setTimeout(function () { main.src = src; if (srcset) main.srcset = srcset; main.style.opacity = '1'; }, 120); }
      thumbs.forEach(function (x, k) { x.classList.toggle('on', k === i); });
      if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      gdots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showMedia(i); }); });
    // swipe en móvil sobre la imagen principal
    var galMain = qs(pdp, '[data-fr-gal-main]');
    if (galMain && thumbs.length > 1) {
      var x0 = null, cur = 0;
      galMain.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      galMain.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        cur = (cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        showMedia(cur);
      });
    }

    // barra fija: se engancha al formulario principal
    document.addEventListener('fr:sticky-add', function () {
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
    sync();
  }

  /* ---------------- barra fija de compra ---------------- */
  function initSticky(root) {
    var bar = (root.nodeType === 1 && root.matches('[data-fr-sticky]')) ? root : qs(root, '[data-fr-sticky]');
    if (!bar || bar.__fr) return; bar.__fr = true;
    var name = qs(bar, '[data-fr-sticky-name]');
    var price = qs(bar, '[data-fr-sticky-price]');
    var btn = qs(bar, '[data-fr-sticky-btn]');
    var tpl = bar.getAttribute('data-name-template') || '{name}';
    document.addEventListener('fr:pack', function (e) {
      if (name && e.detail.name) name.textContent = tpl.replace('{name}', e.detail.name);
      if (price) price.textContent = e.detail.priceText;
    });
    if (btn) btn.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('fr:sticky-add')); });
    var anchor = document.querySelector('.fr-qty');
    function check() {
      if (window.innerWidth > DESKTOP) { bar.classList.remove('is-on'); return; }
      if (!anchor) { bar.classList.add('is-on'); return; }
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------------- "ver más" ---------------- */
  function initMore(root) {
    qsa(root, '[data-fr-more]').forEach(function (b) {
      if (b.__fr) return; b.__fr = true;
      b.addEventListener('click', function () {
        var target = qs(root, b.getAttribute('data-fr-more'));
        if (target) target.classList.add('show-all');
        b.hidden = true;
      });
    });
  }

  /* ---------------- cabecera: cajones (carrito y menú) ---------------- */
  function initHeader(root) {
    qsa(root, '[data-fr-drawer]').forEach(function (b) {
      if (b.__fr) return; b.__fr = true;
      b.addEventListener('click', function (e) {
        var id = b.getAttribute('data-fr-drawer');
        var d = document.getElementById(id);
        if (d && typeof d.toggle === 'function') { e.preventDefault(); d.toggle(); }
        else if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); }
        else if (b.getAttribute('data-fr-fallback')) { window.location.href = b.getAttribute('data-fr-fallback'); }
      });
    });
    qsa(root, '[data-fr-drawer-close]').forEach(function (b) {
      if (b.__fr) return; b.__fr = true;
      b.addEventListener('click', function () {
        var d = b.closest('theme-drawer'); if (d && d.close) d.close();
      });
    });
  }

  function init(root) {
    root = root || document;
    initHeader(root);
    initScroller(root); initTabs(root); initMarquee(root); initVideos(root); initFaq(root);
    initSticky(root); initProduct(root); initMore(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Editor de temas: reinicializa la sección que se carga o selecciona
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.Fresia = { init: init };
})();
